export default __webpack_public_path__ + "static/media/complementary--weight-limit--g1.bdc6c055.png";